<template>
  <v-dialog
    v-model="planDialog"
    width="300px">
    <div class="dialog-container">
      <div class="plan-header">
        <div class="info flex">
          <span >Add Hold Dollars To Referrer</span>
          <i
            class="el-icon-close"
            @click="handlerCancel"></i>
        </div>
      </div>
      <div class="dialog-body">
        <div class="flex-content">
          <div class="flex-box">
            <div
              class="flex-info ">
              <span >
                Referrer
              </span>
              <span
                class="hand blue"
                @click="hanlderCustomer">{{form.referrer}}</span>
            </div>
            <div
              class="flex-info ">
              <span >
                Add Hold Dollars
              </span>
              <v-input
                v-if="!showConfirm"
                v-model="dollars"></v-input>
              <span v-else>{{dollars}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex footer-button">
        <v-button @click="handlerCancel">Cancel</v-button>
        <v-button
          v-if="!showConfirm"
          type="success"
          @click="handlerNext">Next</v-button>
        <v-button
          v-if="showConfirm"
          type="success"
          @click="ConfirmCoupon">Confirm</v-button>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'AddDollarDialog',
  mixins: [MixinOptions, MixinFormat],
  props: {
    customer: {
      type: Object,
      default: () => ({})
    },
    form: {
      type: Object,
      default: () => ({})
    },
    customer_id:{
      type:[String,Number],
      default:''
    }
  },
  data() {
    return {
      planDialog: false,
      dollars:'',
      showConfirm:false
    }
  },
  computed:{

  },
  watch:{
  },
  methods: {
    changeDialog() {
      this.planDialog = !this.planDialog
      this.showConfirm = false
    },
    handlerCancel(){
      this.showConfirm = false
      this.planDialog =false
    },
    handlerNext(){
      if(this.dollars)
        this.showConfirm = true
    },
    ConfirmCoupon() {
      this.planDialog = false
      this.$emit('setVoid', this.dollars)
    },
    hanlderCustomer(){
      this.$router.push({
        path:'/accounts/detail',
        query:{
          customer_id:this.customer_id
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog{
  border-radius: 4px;
}
.dialog-container {
  //padding: 15px;
  border-radius: 5px;

  .plan-header {
    background: #F6F8FA;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px 10px 10px;
      font-size: 14px;
      font-weight: 600;
      color: #24292E;

      i {
        font-weight: 600;
        font-size: 14px;
      }
    }
  }

  .title-span {
    color: #24292E;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  .dialog-body {
    padding: 15px;
    max-height: 800px;
    overflow-y: auto;
  }

  .footer-button {
    padding: 15px;
    justify-content: space-between;
  }

  .tip {
    color: #586069;
    font-weight: 500;
  }

  .flex-content {
    //width: 280px;
    .padding {
      padding: 10px;
    }

    .flex-box {
      //border-radius: 5px;
      //border: 1px solid #E1E4E8;
      //width: 280px;
      //margin: 16px 0;

      .flex-info {
        display: flex;
        flex-direction: column;
        //padding: 23px 15px;
        //border-bottom: 1px solid #E1E4E8;

        span {
          color: #24292E;
          font-size: 14px;
          margin-bottom: 15px;
          font-weight: 500;
        }

      }

      .coupon-button {
        .el-button {
          width: 100%;
        }

        .margin-right {
          margin-right: 10px;
        }
      }
    }
  }
  .blue{
    color: #0366D6!important;
  }
}
</style>